import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToHashId = (opts?: ScrollIntoViewOptions) => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) {
            return;
        }

        const frame = requestAnimationFrame(() => {
            const elementId = location.hash.slice(1);
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView(opts ?? { behavior: 'smooth' });
            }
        });

        return () => cancelAnimationFrame(frame);
    }, [location.hash, opts]);
};

export { useScrollToHashId };
